import type { Route } from 'model';

const routes: Route[] = [
  {
    id: 'london-epping-forest-10k',
    name: 'Epping Forest Trail',
    location: 'London, England',
    description:
      'A 10km trail run through Epping Forest, one of the largest open spaces in London. The route winds through ancient woodland with varied terrain.',
    gpxFile: '/gpx/london_epping_forest_10k.gpx',
    tags: ['running', 'england', '10k', 'trail', 'forest', 'nature', 'hills']
  },
  {
    id: 'cyprus-athalassa-15k',
    name: 'Athalassa National Forest Park 15K',
    location: 'Nicosia, Cyprus',
    description:
      'A 15km trail through the beautiful Athalassa National Forest Park, one of the largest green areas in Nicosia. The route winds through pine forests, open meadows, and past the scenic Athalassa Lake.',
    gpxFile: '/gpx/cyprus_athlasas_15k.gpx',
    tags: ['running', 'cyprus', '15k', 'trail']
  },
  {
    id: 'cyprus-latchi-11k',
    name: 'Latchi Trail Run',
    location: 'Latchi, Cyprus',
    description:
      'An 11km trail run near the picturesque fishing village of Latchi on the northwest coast of Cyprus. The route explores the stunning Akamas Peninsula with Mediterranean views and rugged coastal terrain.',
    gpxFile: '/gpx/cyprus_latchi_11k.gpx',
    tags: ['running', 'cyprus', '11k', 'trail', 'coastal']
  },
  {
    id: 'israel-neotgolan-10k',
    name: 'Neot Golan Trail Run',
    location: 'Golan Heights, Israel',
    description:
      'A 10km trail run through the scenic Golan Heights. The route offers stunning views of the surrounding valleys and volcanic landscape of northern Israel.',
    gpxFile: '/gpx/israel_neotgolan_10k.gpx',
    tags: ['running', 'israel', '10k', 'trail']
  },
  {
    id: 'cyprus-adonis-trail-9k',
    name: 'Adonis Trail',
    location: 'Akamas Peninsula, Cyprus',
    description:
      'A 9km trail through the mythical Adonis Trail in the Akamas Peninsula. Named after the Greek god of beauty, this route passes through stunning natural landscapes, gorges, and Mediterranean flora.',
    gpxFile: '/gpx/cyprus_adonis_trail_9k.gpx',
    tags: ['running', 'cyprus', '9k', 'trail', 'nature']
  },
  {
    id: 'cyprus-limassol-hills-10k',
    name: 'Limassol Hills Trail',
    location: 'Limassol, Cyprus',
    description:
      'A 10km trail run through the hills above Limassol. The route explores the scenic countryside and offers views of the Mediterranean coastline',
    gpxFile: '/gpx/cyprus_limasol_hills_10k.gpx',
    tags: ['running', 'cyprus', '10k', 'trail']
  },
  {
    id: 'scotland-edinburgh-10k',
    name: 'Edinburgh Portobello Run',
    location: 'Edinburgh, Scotland',
    description:
      'A 10km run along the Edinburgh coastline through Portobello promenade. A flat, easy route perfect for a relaxed seaside run with views of the Firth of Forth.',
    gpxFile: '/gpx/scotland_easy_run_10k.gpx',
    tags: ['running', 'scotland', '10k', 'coastal', 'urban']
  },
  {
    id: 'london-city-21k',
    name: 'London City Half Marathon',
    location: 'London, England',
    description:
      'A 21km urban run through North London, passing through Camden, Kings Cross, and surrounding neighbourhoods. A great half marathon distance route through the heart of the city.',
    gpxFile: '/gpx/london_city_run_21k.gpx',
    tags: ['running', 'england', '21k', 'urban', 'half-marathon']
  },
  {
    id: 'us-carolina-14k',
    name: 'Company Mill Trail',
    location: 'North Carolina, USA',
    description:
      'A 14km hiking trail through the Company Mill area near Raleigh. A scenic woodland hike through the forests of North Carolina.',
    gpxFile: '/gpx/us_coroline_14k.gpx',
    tags: ['running', 'usa', '14k', 'trail', 'nature']
  },
  {
    id: 'cyprus-limassol-salt-lake-18k',
    name: 'Limassol Salt Lake Trail',
    location: 'Limassol, Cyprus',
    description:
      'An 18km trail around the scenic Limassol Salt Lake. This route circles the salt flats, offering views of migratory flamingos in season and the surrounding Mediterranean landscape.',
    gpxFile: '/gpx/limsal_salt_lake_18.gpx',
    tags: ['running', 'cyprus', '18k', 'trail', 'nature']
  },
  {
    id: 'us-los-angeles-hills-12k',
    name: 'Los Angeles Hills Trail',
    location: 'Los Angeles, California, USA',
    description:
      'A 12km trail run through the hills of Los Angeles. This route offers scenic views of the city and surrounding mountains while exploring the rugged terrain of the LA hillside.',
    gpxFile: '/gpx/us_los_angeles_hills_12k.gpx',
    tags: ['running', 'usa', '12k', 'trail', 'hills']
  },
  {
    id: 'london-outer-orbital-path',
    name: 'London Outer Orbital Path (LOOP)',
    location: 'Greater London, England',
    description:
      'A 150-mile long-distance walking route encircling Greater London, often called the "M25 for walkers". Split into 24 sections, the LOOP traces a green ring through the capital\'s outer countryside, parks, woodlands, rivers and historic villages, showcasing surprising rural pockets on the edge of the city.',
    gpxFile: '/gpx/londonouterorbitalpath.gpx',
    tags: ['walking', 'england', 'london', 'long-distance', 'trail', 'nature']
  },
  {
    id: 'greece-loutraki-10k',
    name: 'Loutraki Coastal Run',
    location: 'Loutraki, Greece',
    description:
      'A 10km run around the seaside resort of Loutraki on the Gulf of Corinth. The route follows the coastline with views across the bay and the surrounding mountains.',
    gpxFile: '/gpx/greece_lutraki_10k.gpx',
    tags: ['running', 'greece', '10k', 'coastal']
  },
  {
    id: 'japan-kanazawa-13k-up',
    name: 'Kanazawa Sai river (down)',
    location: 'Kanazawa, Japan',
    description: 'A 13km up the Sai river. Nice and flats, the firther you go the more rural it gets.',
    gpxFile: '/gpx/kanazawa_13k_up.gpx',
    tags: ['running', 'japan', '13k', 'trail', 'hills']
  },
  {
    id: 'japan-kanazawa-14k-down',
    name: 'Kanazawa Sai river (up)',
    location: 'Kanazawa, Japan',
    description: 'A 14km down the Kanazawa river towards the sea. Flat and fast. Nice in the night as wll as the day.',
    gpxFile: '/gpx/kanazawa_14k_down.gpx',
    tags: ['running', 'japan', '14k', 'trail', 'hills']
  },
  {
    id: 'japan-kyoto-13k',
    name: 'Kyoto Kamo River',
    location: 'Kyoto, Japan',
    description: 'A 13km run through the city of Kyoto along the Kamo River.',
    gpxFile: '/gpx/kyoto_13k.gpx',
    tags: ['running', 'japan', '13k', 'urban']
  },
  {
    id: 'japan-kyoto-30k-challenging',
    name: 'Kyoto 30K Hills',
    location: 'Kyoto, Japan',
    description:
      'A challenging 30km route in and around Kyoto with 1,401m of elevation gain, climbing into the surrounding hills and forested mountains. Very hilly, rocky and challanging terrein. A demanding long-distance run combining temples with steep trail sections.',
    gpxFile: '/gpx/kyoto_30_challenging.gpx',
    tags: ['running', 'japan', '30k', 'trail', 'hills', 'long-distance']
  },
  {
    id: 'japan-tokyo-10k',
    name: 'Tokyo 10k City Run',
    location: 'Tokyo, Japan',
    description:
      'A 10km urban run through Tokyo, weaving past parks, neighbourhoods and city landmarks. A flat, fast route showcasing the energy of the Japanese capital. Great for jetlag recovery or a quick city run.',
    gpxFile: '/gpx/tokyo_10k.gpx',
    tags: ['running', 'japan', '10k', 'urban']
  }
];

export default routes;
